import {DisposalSet, select, selectAll} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-chip-set', (fragmentEl, config, meta) => {
    const clearBtnEl = select<HTMLButtonElement>(fragmentEl, '.chroa-chip-set__clear');
    gc.register(clearBtnEl).addListener('click', () => {
        const chips = selectAll<HTMLDivElement>(fragmentEl, '.chroa-chip');
        chips.forEach(chipEl => {
            const parentEl = chipEl?.parentElement?.parentElement;
            if (parentEl) parentEl.remove();

        });
    });
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
